import { render, staticRenderFns } from "./CreateLicenseGroupModal.vue?vue&type=template&id=b38526e0&"
import script from "./CreateLicenseGroupModal.vue?vue&type=script&lang=js&"
export * from "./CreateLicenseGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b38526e0')) {
      api.createRecord('b38526e0', component.options)
    } else {
      api.reload('b38526e0', component.options)
    }
    module.hot.accept("./CreateLicenseGroupModal.vue?vue&type=template&id=b38526e0&", function () {
      api.rerender('b38526e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/CreateLicenseGroupModal.vue"
export default component.exports